export default (navItem, selectedNavPath) => (
  navItem.items.find(
    (subItem) => {
      const currentPath = selectedNavPath;
      const pathMatched = currentPath.startsWith(subItem.path);
      return pathMatched && !subItem.doNotHighlight;
    },
  )
);
